import { render, staticRenderFns } from "./PermissionsGroupTable.vue?vue&type=template&id=6ec27a8c"
import script from "./PermissionsGroupTable.js?vue&type=script&lang=js&external"
export * from "./PermissionsGroupTable.js?vue&type=script&lang=js&external"
import style0 from "./PermissionsGroupTable.vue?vue&type=style&index=0&id=6ec27a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports